import { render, staticRenderFns } from "./CaseDetailsHeader.vue?vue&type=template&id=423a2e50&scoped=true&"
import script from "./CaseDetailsHeader.vue?vue&type=script&lang=ts&"
export * from "./CaseDetailsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDetailsHeader.vue?vue&type=style&index=0&id=423a2e50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423a2e50",
  null
  
)

export default component.exports